import React from "react";

import { AffiliateLine } from "./styles";

export default function Affiliates({ afiliado }) {
  console.log(afiliado);
  if (!afiliado) {
    return <></>;
  }
  return (
    <AffiliateLine>
      {afiliado.usuario.NO_primeiro_nome + " " + afiliado.usuario.NO_ultimo_nome}{" - "}
      {"CPF: " + afiliado.usuario.NU_cpf}
    </AffiliateLine>
  );
}
